import { Link } from "react-router-dom";
import { GUIDES, type Guide } from "../../../components/guide/guides";

/**
 * Library → Introduction. The shelf of guides to reading the Library itself —
 * how our texts are written, and how to recite from them. Shared by the public
 * `/library/introduction` and the dashboard `/dashboard/library/introduction`.
 *
 * Guides are not documents (see components/guide/guides.ts); every one links
 * to `/library/introduction/<slug>`, which the app shell redirects to its
 * dashboard twin like the rest of the Library.
 */
export default function LibraryIntroduction() {
  return (
    <ul className="guide-shelf">
      {GUIDES.map((g) => (
        <li key={g.slug}>
          <GuideCard g={g} />
        </li>
      ))}
    </ul>
  );
}

/** A guide on the shelf, and on the Library's All tab. */
export function GuideCard({ g }: { g: Guide }) {
  return (
    <Link to={`/library/introduction/${g.slug}`} className="guide-card">
      <span className="guide-card__title">{g.title}</span>
      <span className="guide-card__sub">{g.subtitle}</span>
      <span className="guide-card__blurb">{g.blurb}</span>
    </Link>
  );
}
